import React from "react";
import { useTranslation } from "react-i18next";
import educationData from "../../i18n/education_levels.json"; // Import the education levels JSON

const GradeLevelSelector = ({ selectedGrades, setSelectedGrades }) => {
  const { t } = useTranslation();

  // Extract education levels and their grades from the JSON data
  const educationLevels = educationData.map((level) => ({
    value: level.value,
    display: level.display[t("language")], // Use current language from i18n
  }));

  const handleToggle = (gradeValue) => {
    setSelectedGrades((prev) =>
      prev.includes(gradeValue)
        ? prev.filter((g) => g !== gradeValue)
        : [...prev, gradeValue]
    );
  };

  return (
    <div>
      <label>{t("ad.gradeLevel")}</label>
      <div className="flex flex-wrap">
        {educationLevels.map((level) => (
          <span
            key={level.value}
            onClick={() => handleToggle(level.value)}
            className={`Select-tag ${
              selectedGrades?.includes(level.value)
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-800"
            }`}
          >
            {level.display}
          </span>
        ))}
      </div>
    </div>
  );
};

export default GradeLevelSelector;
